import { Dropdown, typography } from '@joor/design-system'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  label {
    margin: 0;
  }
`

export const LinesheetsDropdownContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 400px;

  .caption {
    margin-top: 3px !important;
    color: var(--color-primary-500) !important;
  }

  .label {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
    padding: 0;
    ${typography.alpha.primaryActive.body3}

    & > label {
      font-weight: var(--font-weight-medium);
    }
  }
`

export const StyledDropdown = styled(Dropdown)`
  width: 400px;

  & input {
    font-family: var(--font-family-alpha) !important;
    line-height: var(--line-height-16) !important;
    width: auto !important;
  }
`

export const DoorDropdownInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  gap: 8px;

  & > span {
    cursor: pointer;
    margin: 0 0 8px;
  }
`
